import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import {
  BrowserRouter as Router,
  Link,
  Route,
  Switch,
} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },
  input: {
    display: 'none',
  },
}));

function OutlinedButtons() {
  const classes = useStyles();

  return (
    <div>
    <br />
    <br />

    <Button variant="outlined" style={{color:'#686ba8',borderColor:'#686ba8'}} className={classes.button}>
    <a style={{textDecoration: 'none', color:'inherit'}} href="tel:8475481588">Call Us Now</a>
    </Button>
      <Button component={Link} style={{color:'#686ba8',borderColor:'#686ba8'}} to={'/requestquote'} variant="outlined"  color="primary" className={classes.button}>
        Request Quote

      </Button>


    </div>
  );
}

export default OutlinedButtons;
